<template>
  <div class="setup-step complete-step">
    <div class="complete-icon">
      <CheckIcon />
    </div>
    <h3>{{ s__('ProjectSetup|Setup Complete!') }}</h3>
    <p class="step-description">
      {{
        s__(
          "ProjectSetup|You've successfully configured your project settings. You can change these settings anytime in project settings."
        )
      }}
    </p>

    <div class="actions">
      <a :href="tasksUrl" class="btn-primary">
        {{ s__('ProjectSetup|Go to Project') }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { s__ } from '@/locale'
import CheckIcon from '../../common/icons/CheckIcon.vue'

defineProps({
  tasksUrl: {
    type: String,
    required: true,
  },
})
</script>

<style scoped>
.complete-step {
  text-align: center;
  padding: 40px 20px;
}

.complete-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  color: #2aabee;
}

.complete-icon svg {
  width: 64px;
  height: 64px;
}

.setup-step h3 {
  margin-top: 0;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.step-description {
  margin-bottom: 32px;
  color: #666;
  font-size: 16px;
  line-height: 1.5;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.actions {
  margin-top: 32px;
}

.btn-primary {
  display: inline-block;
  padding: 12px 24px;
  background-color: #1d6bf3;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #1557c7;
}
</style>
